import ActivityItem from './ActivityItem';

export default ActivityItem;
